import { render, staticRenderFns } from "./addPubs.vue?vue&type=template&id=3c2e825a&scoped=true&"
import script from "./addPubs.vue?vue&type=script&lang=js&"
export * from "./addPubs.vue?vue&type=script&lang=js&"
import style0 from "./addPubs.vue?vue&type=style&index=0&id=3c2e825a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e825a",
  null
  
)

export default component.exports